import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { connect } from 'react-redux';
import OpportunityBox from '../opportunity-box';
import AccountBox from '../account-box';
import Fa from 'react-fontawesome';
import { toast } from 'react-toastify';
import { Modal, Button } from 'react-bootstrap';
import OutreachPlanModal from '../../../Feedback/components/outreach-plan-modal';
import InsightModal from '../../../Feedback/components/sidebox/InsightModal';
import { getUser, getCanSetupOrganization } from '../../../Auth/AuthReducer';
import { getWinLossCollectorStats } from '../../../Dashboard/DashboardReducer';
import ColumnDataManager from '../../../../components/god-table/column-data-manager';
import ExcludeOpportunityForm from '../../../Feedback/components/opportunity-box/ExcludeOpportunityForm';
import SurveyEmailModal from '../../../Dashboard/components/SurveyEmailModal';
import EditSenderModal from '../../../Feedback/components/edit-sender-modal';
import AutomationTestModal from '../../../Setup/pages/DiscoveryBotPage/AutomationTestModal';
import CommunicationRecipientModal from '../../components/communication-recipient';

import EditLanguageModal from '../../../Feedback/components/edit-language-modal';
import { 
  resetOpportunityAutomationSettings,
  resetAccountAutomationSettings,
  sendSummaryEmail,
  sendReminderEmail,
} from '../../../Setup/SetupActions';

import {
  fetchWinLossOpportunitySurveys,
  fetchWinLossAccountSurveys,
  winLossExcludeOpportunity,
  winLossExcludeAccount,
  winLossIncludeAccount,
  winLossIncludeOpportunity,
  requestEditWinLossAccountFeedbacks,
  requestEditWinLossOpportunityFeedbacks,
  fetchOpportunityRequestStatus,
  fetchInsights,
  updateReminderEmailStatus,
  updateAccountStatus,
} from '../../../Dashboard/DashboardActions';
import createRequestFeedbackComponent, { OPPORTUNITY_COMPONENT_TYPE, ACCOUNT_COMPONENT_TYPE } from '../../../Dashboard/components/WinLossOpportunityTable/RequestOpportunityFeedbacks';

class ResourceBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: null,
      colorPallete: null,
      currentlyExcludedResource: null,
      currentSurveyPlan: null,
      currentEditSenderSurvey: null,
      showTestModal: false,
      testAutomationId: null,
      currentEditCommnunicationRecipient: null,

      currentEditLanguageSurvey: null,
      changeLanguageCallback: null,
      selectedLanguage: null,
      availableLanguages: [],
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnAccountLogoLoaded = this.handleOnAccountLogoLoaded.bind(this);
    this.requestExcludeResource = this.requestExcludeResource.bind(this);
    this.handleExcludeResource = this.handleExcludeResource.bind(this);
    this.handleIncludeResource = this.handleIncludeResource.bind(this);
    this.handleRequestAddResourceSurvey = this.handleRequestAddResourceSurvey.bind(this);

    this.requestShowOutreachPlan = this.requestShowOutreachPlan.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.handleRequestRunTest = this.handleRequestRunTest.bind(this);
    this.hideTestModal = this.hideTestModal.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.handleRequestPauseReminderEmail = this.handleRequestPauseReminderEmail.bind(this);
    this.handleRequestSendSummaryEmail = this.handleRequestSendSummaryEmail.bind(this);
    this.handleRequestSendReminderEmail = this.handleRequestSendReminderEmail.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.handleUpdateAccountStatus = this.handleUpdateAccountStatus.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.RequestOpportunityFeedbacks = createRequestFeedbackComponent(props.isAccount ? ACCOUNT_COMPONENT_TYPE : OPPORTUNITY_COMPONENT_TYPE);

    this.loadSettings();
  }
  

  loadSettings() {
    const { isAccount, resourceId } = this.props;
    if (resourceId) {
      const requestedIds = [resourceId];
      const resetAction = isAccount ? resetAccountAutomationSettings : resetOpportunityAutomationSettings;
      this.props.dispatch(fetchOpportunityRequestStatus([resourceId], requestedIds, isAccount ? 'account' : 'opportunity'));
      this.props.dispatch(resetAction());
    }

  }


  handleUpdateAccountStatus(account, status) {
    const p = this.props.dispatch(updateAccountStatus(account.account_id, status));
    return p;
  }


  requestShowOutreachPlan(survey) {
    const { isAccount, resourceId } = this.props;
    this.setState({ currentSurveyPlan: { ...survey, object_id: resourceId } });
    return Promise.resolve();
  }

  handleRequestShowInsight(insightId) {
    const { resourceId } = this.props;
    this.props.dispatch(fetchInsights(resourceId, insightId));
  }

  handleRequestRunTest(resource, automationId = null) {
    this.setState({ showTestModal: true, testAutomationId: automationId });
  }

  closeModal() {
    this.props.closeModal();
  }

  hideTestModal() {
    this.setState({ showTestModal: false }, () => {
      this.setState({
        testAutomationId: null,
      });
    });
  }

  handleRequestSendSummaryEmail(opportunity, automationId = null) {
    this.handleSendEmail('summary', opportunity, automationId);
  }

  handleRequestSendReminderEmail(opportunity, automationId = null) {
    this.handleSendEmail('reminder', opportunity, automationId);
  }

  handleSendEmail(type, resource, automationId) {
    const { resourceId } = this.props;
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> Sending {type} email for <strong>{resource.name}</strong>...</div>
    );

    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });

    const action = type === 'reminder' ? sendReminderEmail : sendSummaryEmail;
    this.props.dispatch(action(automationId, resourceId))
      .then(
        (result) => {
          const hasError = result.error === true;
          const el = hasError ? 
              (<div>{result.message}. A {type} email has not been sent for <strong>{resource.name}</strong></div>) :
              (<div>{capitalize(type)} email has been sent for <strong>{resource.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: hasError ? 'error' : 'success',
              autoClose: !hasError,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: hasError ? 'error' : 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
  }

  requestChangeLanguage(currentEditLanguageSurvey, selectedLanguage, availableLanguages, changeLanguageCallback = () => {}) {
    this.setState({
      currentEditLanguageSurvey,
      selectedLanguage,
      availableLanguages,
      changeLanguageCallback,
    });
    return Promise.resolve();
  }


  requestChangeCommnunicationRecipient(currentEditCommnunicationRecipient) {
    this.setState({ currentEditCommnunicationRecipient });
    return Promise.resolve();
  }


  requestChangeSenderEmail(survey) {
    const { isAccount, resource, resourceId } = this.props;

    this.setState({
      currentEditSenderSurvey: {
        ...survey,
        object_id: resourceId,
        object: resource,
      },
    });
    return Promise.resolve();
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  handleOnAccountLogoLoaded(accountLogoUrl, colorPallete) {
    this.setState({ colorPallete });
  }

  requestExcludeResource(currentlyExcludedResource) {
    this.setState({ currentlyExcludedResource });
  }

  handleIncludeResource(resource) {
    const { isAccount, resourceId } = this.props;
    const includeAction = isAccount ? winLossIncludeAccount : winLossIncludeOpportunity;
    const p = this.props.dispatch(includeAction(resourceId));
    return p;
  }


  handleExcludeResource(resource, params) {
    const { isAccount, resourceId } = this.props;
    const excludeAction = isAccount ? winLossExcludeAccount : winLossExcludeOpportunity;
    const reloadAction = isAccount ? fetchWinLossAccountSurveys : fetchWinLossOpportunitySurveys;
    const p = this.props.dispatch(excludeAction(resourceId, params));
    p.then(() => { 
      this.props.dispatch(reloadAction(resourceId)); 
    });
    return p;  
  }


  handleRequestPauseReminderEmail(resource, pause = false) {
    const { resourceId } = this.props;

    const p = this.props.dispatch(updateReminderEmailStatus(resourceId, pause, false));
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> {pause ? 'Pause' : 'Resume'} reminder email...</div>
    );
    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
    p.then(
        (result) => {
          const el = (<div>Reminder email has been {result.disabled ? 'paused' : 'resumed'} for <strong>{resource.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'success',
              autoClose: true,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
    return p;
  }


  handleRequestAddResourceSurvey(resource, contact) {
    if (this.props.isAccount) {
      this.props.dispatch(requestEditWinLossAccountFeedbacks(resource));
    } else {
      this.props.dispatch(requestEditWinLossOpportunityFeedbacks(resource, contact));
    }
  }
  
  render() {
    const { 
      selectedTab, colorPallete,
      currentlyExcludedResource,
      currentSurveyPlan,
      currentEditSenderSurvey,
    } = this.state;
    const {
      isAccount,
      auth, resource, resourceId, collectorStats,
      automation, canSetupOrg,
      modalMode, showModal,
    } = this.props;

    
    const BoxCls = isAccount ? AccountBox : OpportunityBox;

    const props = {
      ...(isAccount ? {
        account: resource.account,
        excludeAccount: this.requestExcludeResource,
        includeAccount: this.handleIncludeResource,
        requestAddAccountSurvey: this.handleRequestAddResourceSurvey,
        updateAccountStatus: this.handleUpdateAccountStatus,
        amountField: 'ttm',
      } : {
        opportunity: resource,
        excludeOpportunity: this.requestExcludeResource,
        includeOpportunity: this.handleIncludeResource,
        requestAddOpportunitySurvey: this.handleRequestAddResourceSurvey,
      }),
      auth,
      isVisible: true,
      collectorStats: collectorStats[resourceId],
      onTabSelect: this.handleTabSelect,
      onLogoLoaded: this.handleOnAccountLogoLoaded,
      tab: selectedTab,
      colorPallete,
      requestShowInsight: this.handleRequestShowInsight,
      requestShowOutreachPlan: this.requestShowOutreachPlan,
      requestChangeSenderEmail: this.requestChangeSenderEmail,
      requestChangeLanguage: this.requestChangeLanguage,
      requestCancelContact: this.handleRequestCancelContact,
      showRunTestButton: canSetupOrg,
      requestRunTest: this.handleRequestRunTest,
      emailAutomationsEnabled: true,
      requestChangeCommnunicationRecipient: this.requestChangeCommnunicationRecipient,
      enableChangeCommnunicationRecipient: true,
      requestPauseReminderEmail: this.handleRequestPauseReminderEmail,
      showSendSummaryEmailButton: canSetupOrg,
      requestSendSummaryEmail: this.handleRequestSendSummaryEmail,
      showSendReminderEmailButton: canSetupOrg,
      requestSendReminderEmail: this.handleRequestSendReminderEmail,
    };

    let comp = (<BoxCls {...props} />);
    if (modalMode) {
      comp = (
        <Modal key="modal" bsSize="lg" show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton><Modal.Title>{resource?.name}</Modal.Title></Modal.Header>
          <Modal.Body>
            {comp}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="default" onClick={this.closeModal}>Done</Button>
          </Modal.Footer>
        </Modal>
      );
    }


    return (
      <div>
        {comp}
        <ColumnDataManager 
          id={isAccount ? 'account-feedback-tile' : 'feedback-tile'}
          key={resourceId}
          getRowData={() => [resource]}
          resourceType={isAccount ? 'ACCOUNT' : 'OPPORTUNITY'}
          onColumnLoaded={() => {}}
          forceLoadSystemColumnTags={['productDetails', 'contactDetails']}
        />

        <ExcludeOpportunityForm
          isAccount={isAccount}
          opportunity={currentlyExcludedResource}
          auth={auth}
          show={currentlyExcludedResource !== null}
          onClose={() => { this.setState({ currentlyExcludedResource: null }); }}
          requestExclude={this.handleExcludeResource}
        />

        <this.RequestOpportunityFeedbacks
          collectorTypes={isAccount ? ['experience'] : ['decision']}
          withPreferCollector
          requestCancelContact={this.handleRequestCancelContact}
          requestChangeLanguage={this.requestChangeLanguage}
          requestExclude={this.requestExcludeOpportunity}
          automationId={automation?._id}
        />

        <OutreachPlanModal
          isAccount={isAccount}
          survey={currentSurveyPlan}
          onClose={() => { this.setState({ currentSurveyPlan: null }); }}
        />

        <InsightModal />
        <SurveyEmailModal />

        <EditSenderModal
          isAccount={isAccount}
          survey={currentEditSenderSurvey}
          onClose={() => { this.setState({ currentEditSenderSurvey: null }); }}
          onSuccess={() => {}}
        />

        {canSetupOrg &&
          <AutomationTestModal
            open={this.state.showTestModal}
            onClose={this.hideTestModal}
            ownerId={this.props.resource.owner_id}
            automationId={this.state.testAutomationId}
            isAccount={isAccount}
            {...{ [isAccount ? 'accountId' : 'opportunityId']: this.props.resourceId }}
          />
        }

        <CommunicationRecipientModal
          object={this.state.currentEditCommnunicationRecipient}
          onClose={() => { this.setState({ currentEditCommnunicationRecipient: null }); }}
          isAccount={isAccount}
          onSuccess={() => { 
            this.setState({ currentEditCommnunicationRecipient: null });
          }}
        />

        <EditLanguageModal
          survey={this.state.currentEditLanguageSurvey}
          selectedLanguage={this.state.selectedLanguage}
          availableLanguages={this.state.availableLanguages}
          isAccount={isAccount}
          onClose={() => {
            this.setState({
              currentEditLanguageSurvey: null,
              selectedLanguage: null,
              availableLanguages: [],
              changeLanguageCallback: null,
            });
          }}
          onSuccess={(c) => {
            if (this.state.changeLanguageCallback) {
              this.state.changeLanguageCallback(c);
              this.setState({ changeLanguageCallback: null });
            }
          }}
        />
      </div>
    );
  }
}

ResourceBox.propTypes = {
  auth: PropTypes.shape({}).isRequired,
  resource: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  isAccount: PropTypes.bool,
  resourceId: PropTypes.string,
  collectorStats: PropTypes.shape({}),
  automation: PropTypes.shape({
    _id: PropTypes.string,
  }),
  canSetupOrg: PropTypes.bool,
  modalMode: PropTypes.bool,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

ResourceBox.defaultProps = {
  isAccount: false,
  collectorStats: {},
  automation: null,
  canSetupOrg: false,
  modalMode: false,
  showModal: false,
  closeModal: () => {},
};

ResourceBox.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};



function mapStateToProps(state, ownProps) {

  const resourceId = ownProps.isAccount ? ownProps.resource?.account_id : ownProps.resource?.opportunity_id;

  return {
    auth: getUser(state),
    collectorStats: getWinLossCollectorStats(state),
    resourceId,
    canSetupOrg: getCanSetupOrganization(state),
  };
}

export default connect(mapStateToProps)(ResourceBox);
